import { Alert, IconDocumentBroken, Strong, Text } from 'braid-design-system';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';
import { BasePage } from '#src/components/BasePage/BasePage.tsx';

import { NavActions } from '#src/components/NavActions/NavActions.tsx';
import { useStaticRender } from '#src/hooks/staticRender.tsx';

export const OopsPage = () => {
  const staticRender = useStaticRender();

  const location = useLocation();

  return (
    <BasePage
      title={{
        icon: <IconDocumentBroken />,
        children: staticRender ? '/' : location.pathname,
        stringTitle: staticRender ? '/' : location.pathname,
      }}
      breadcrumbs={null}
    >
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>

      <Alert tone="caution">
        <Text>
          <Strong>404</Strong>, we can’t seem to find what you’re looking for!
        </Text>
      </Alert>

      <NavActions />
    </BasePage>
  );
};
